module.exports = __webpack_public_path__ + "static/media/trx.dc5852ac.png";